import { useRef, useState } from "react";
import { Loader2, UploadCloud, X, ImageIcon } from "lucide-react";
import { toast } from "sonner";
import { uploadCampaignImage, resolveMedia } from "@/api/client";

// A compact image upload/preview widget. Stores the object-storage path (or a
// pasted URL) via onChange. Used for canto covers, galleries, arrival photos.
export const ImageSlot = ({ campaignId, value, onChange, aspect = "aspect-[4/5]", testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const res = await uploadCampaignImage(campaignId, file);
      onChange(res.path);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed (max 10MB, jpg/png/webp)");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  return (
    <div className="group relative overflow-hidden rounded-xl border border-amber-300/15 bg-[#080b16]/60" data-testid={testId}>
      <div className={`${aspect} w-full`}>
        {value ? (
          <img src={resolveMedia(value)} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="grid h-full w-full place-items-center text-amber-300/40">
            <ImageIcon className="h-6 w-6" />
          </div>
        )}
      </div>
      <div className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 bg-gradient-to-t from-black/80 to-transparent p-2 opacity-0 transition-opacity group-hover:opacity-100">
        <input ref={ref} type="file" accept="image/*" onChange={onFile} className="hidden" />
        <button
          onClick={() => ref.current?.click()}
          disabled={busy}
          className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-2.5 py-1 text-[11px] font-semibold text-[#0a0f24] hover:bg-amber-300 disabled:opacity-60"
        >
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <UploadCloud className="h-3 w-3" />}
          Upload
        </button>
        {value && (
          <button
            onClick={() => onChange("")}
            className="inline-flex items-center gap-1 rounded-full border border-red-400/30 px-2 py-1 text-[11px] text-red-300 hover:bg-red-500/10"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </div>
    </div>
  );
};
